module.exports = __webpack_public_path__ + "img/logo.fb293b02.svg";